<template>
  <div class="notification is-info" role="note">
    <p>
      Οι παρακάτω σελίδες υπάρχουν μόνο στο eshop. Αν βάλετε link προς αυτές,
      στο Ψηφιακό Ράφι (Bookshelf) θα ανοίγει σελίδα 404:
    </p>
    <ul class="unsupported-paths">
      <li v-for="path in paths" :key="path">{{ path }}</li>
    </ul>
    <p>
      Links σε άλλα sites (εκτός carespot.gr) δεν ανοίγουν στο Ψηφιακό Ράφι.
    </p>
  </div>
</template>
<script>
import paths from '@/constants/bookshelfUnsupportedPaths';

export default { data: () => ({ paths }) };
</script>
<style scoped>
.unsupported-paths {
  list-style: disc;
  margin: 0.75rem 0 0.75rem 1.5rem;
}
</style>
